import { useSelector } from 'react-redux';
import { useCurrentUser } from '@mews-commander/core';
import { DetailedUser, SecurityFeatures } from '@mews-commander/data-access';
import { hasPlatformScopeWithAccessAllEnterprises } from '@mews-commander/legacy-entities/src/ducks/scopes';
import {
    hasCurrentProfilePlatformScope,
    getCurrentScope,
} from '@mews-commander/legacy-entities/src/selectors/session/scope';

export const useCanSeeMfaReset = (user: Pick<DetailedUser, 'securityFeatures' | 'userId'> | undefined) => {
    const currentScope = useSelector(getCurrentScope);
    const { id: currentUserId } = useCurrentUser();
    const canAccessAllEnterprises: boolean = useSelector(hasPlatformScopeWithAccessAllEnterprises);
    const hasPlatformScope: boolean = useSelector(hasCurrentProfilePlatformScope);

    // @ts-expect-error scope options are not typed in openAPI
    const canCurrentProfileResetMfa = currentScope?.options?.resetUsersTwoFactorAuthentication;
    const hasMfaEnabled = user?.securityFeatures?.includes(SecurityFeatures.MfaEnabled);
    const isOwnProfile = user?.userId === currentUserId;
    const isPlatformProfileWithAccessAllEnterprises = hasPlatformScope && canAccessAllEnterprises;

    return hasMfaEnabled && (canCurrentProfileResetMfa || isPlatformProfileWithAccessAllEnterprises) && !isOwnProfile;
};
